module.exports = __webpack_public_path__ + "img/98.4feeafe3.png";